import { type LucideIcon } from 'lucide-react';

type CalloutVariant = 'info' | 'success' | 'warning';

interface InfoCalloutProps {
  icon: LucideIcon;
  title: string;
  description: string;
  variant?: CalloutVariant;
}

const variantStyles: Record<CalloutVariant, string> = {
  info: 'bg-cyan-100/60 border-cyan-200 text-cyan-700',
  success: 'bg-emerald-100/60 border-emerald-200 text-emerald-700',
  warning: 'bg-amber-100/60 border-amber-200 text-amber-700',
};

export function InfoCallout({
  icon: Icon,
  title,
  description,
  variant = 'info',
}: InfoCalloutProps) {
  return (
    <div className={`flex gap-3 p-4 rounded-xl border ${variantStyles[variant]}`}>
      <Icon size={20} strokeWidth={1.5} className="flex-shrink-0 mt-0.5" />
      <div>
        <p className="font-semibold">{title}</p>
        <p className="text-sm opacity-80">{description}</p>
      </div>
    </div>
  );
}
